// src/i18n/index.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr.json';
import en from './locales/en.json';
import ar from './locales/ar.json';

// ✅ Export nommé
export const LANGUAGES = [
  { code: 'fr', label: 'Français', short: 'FR' },
  { code: 'en', label: 'English',  short: 'EN' },
  { code: 'ar', label: 'العربية',  short: 'AR' },
];

const CODES = LANGUAGES.map(l => l.code);
const DEFAULT_LANG = 'fr';

const getInitialLang = () => {
  const saved = localStorage.getItem('lang');
  if (saved && CODES.includes(saved)) return saved;
  const browser = (navigator.language || 'fr').slice(0, 2);
  return CODES.includes(browser) ? browser : DEFAULT_LANG;
};

// ✅ Export nommé
export const applyDirection = (lang) => {
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
};

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: getInitialLang(),
  fallbackLng: DEFAULT_LANG,
  interpolation: { escapeValue: false },
});

// ✅ Export nommé
export const changeLanguage = (lang) => {
  if (!CODES.includes(lang)) return;
  i18n.changeLanguage(lang);
  localStorage.setItem('lang', lang);
  applyDirection(lang);
};

applyDirection(i18n.language);

// ✅ Export par défaut (pour App.js / main.jsx)
export default i18n;